import { INTRO_TEXT_CONFIG } from "../constants/game";
import { assetsImageLoader } from "../utils/funtions";
function IsSafari() {

    var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
    return is_safari;

}
export default class IntroText {
    constructor(context) {
        this.context = context;
        this.started = false;
        this.delay = 3;
    }
    preload() {
        assetsImageLoader(
            {
                'animation': INTRO_TEXT_CONFIG.animation,
            },
            "intro-",
            this.context
        )
    }
    create() {
        this.MEDIA_TYPE = this.context.data.get('mediaType');
        this.container = this.context.add
            .container(
                this.context.game.config.width / 2,
                this.context.game.config.height * .6, []
            )
            .setDepth(INTRO_TEXT_CONFIG.depth);

        this.text = this.context.add.text(
            0, 0,
            INTRO_TEXT_CONFIG.text[this.MEDIA_TYPE],
            INTRO_TEXT_CONFIG.fontStyle[this.MEDIA_TYPE]
        ).setStroke('#de77ae', 4)
            .setShadow(2, 2, "#333333", 2, true, true)//  Apply the shadow to the Stroke and the Fill (this is the default)
            .setOrigin(0.5)
            .setScrollFactor(0)
            .setResolution(2)
            .setDepth(INTRO_TEXT_CONFIG.depth + 1)

        this.container.add(this.text);

    }

    start() {

        const animatedgif = document.createElement("img");
        const img_width = 200;
        const half_width = img_width / 2;
        const saturation = IsSafari ? 836 : 1672;
        animatedgif.src = INTRO_TEXT_CONFIG.animation;
        animatedgif.style.position = "absolute";
        animatedgif.style.width = img_width + "px";
        animatedgif.style.top = `calc(40% - ${half_width}px)`;
        animatedgif.style.left = `calc(50% - ${half_width}px)`;
        animatedgif.style.zIndex = 10;
        animatedgif.style.userSelect = 'none';
        animatedgif.style.webkitUserDrag = 'none';
        // animatedgif.style.filter = "invert(44%) sepia(46%) saturate(6677%) hue-rotate(315deg) brightness(101%) contrast(96%)";
        animatedgif.style.filter = `invert(99%) sepia(63%) saturate(${saturation}%) hue-rotate(279deg) brightness(99%) contrast(89%)`;
        animatedgif.style.opacity = ".6";
        this.context.game.canvas.parentElement.appendChild(animatedgif);

        //-- console.log(animatedgif);
        this.context.tweens.add({
            targets: this.container,
            alpha: 0,
            duration: 5000,
            ease: 'easy-in-out',
            easeParams: [0.4, 0.5],

            onComplete: () => {
                animatedgif.remove();
            }
        })
    }

    update() {

        if (this.context.data.get('isRunning')) {
            this.delay--;
            if (this.delay < 0 && !this.started) {
                this.started = true;
                this.start();
            }
        }
    }

}